import { useState } from 'react'
import { Check } from 'lucide-react'
import CopyButton from '@/frontend/features/LocalMcp/CopyButton'
import type { LocalMcpProps } from '@/frontend/features/LocalMcp/types'

export default function ConnectionSetup({ guide, copy }: { guide: NonNullable<LocalMcpProps['guide']>; copy: LocalMcpProps['copy'] }) {
  const [client, setClient] = useState<'codex' | 'claude'>('codex')
  return (
    <section className="rounded-lg border border-primary/20 bg-primary/5 p-5">
      <div className="flex items-center gap-2 text-sm font-medium"><Check className="size-4 text-primary" />{copy.ready}</div>
      <p className="mt-1.5 text-xs leading-5 text-muted-foreground">{copy.ready_hint}</p>
      <div className="mt-4 flex flex-wrap items-center gap-4">
        <div role="group" aria-label={copy.client} className="inline-flex gap-1 rounded-md border border-border bg-background p-1">
          {(['codex', 'claude'] as const).map((key) => (
            <button key={key} type="button" aria-pressed={client === key} onClick={() => setClient(key)} className={`rounded px-3 py-1.5 text-xs ${client === key ? 'bg-muted font-medium' : 'text-muted-foreground hover:text-foreground'}`}>
              {key === 'codex' ? 'Codex' : 'Claude Code'}
            </button>
          ))}
        </div>
        <CopyButton key={client} value={guide[client]} label={copy.copy_instructions} copy={copy} variant="default" />
      </div>
      <details className="mt-4 text-xs">
        <summary className="w-fit cursor-pointer text-muted-foreground hover:text-foreground">{copy.view_instructions}</summary>
        <pre className="mt-3 whitespace-pre-wrap break-words border-t border-primary/10 pt-3 leading-5">{guide[client]}</pre>
      </details>
    </section>
  )
}
